export default "__VITE_ASSET__sCjOvvWs2tFPVugnccfoZA__"